import {
  FormControl,
  FormControlLabel,
  FormControlProps,
  Checkbox as MuiCheckbox,
  Typography,
} from "@mui/material";
import {
  Controller,
  FieldErrors,
  FieldValues,
  UseControllerProps,
} from "react-hook-form";
import { getError } from "../../../../utils/common";
import InputErrorText from "../Input/InputErrorText";

type InputProps<T extends FieldValues> = UseControllerProps<T> &
  FormControlProps & {
    label?: string;
    errors?: FieldErrors;
  };

const Checkbox = <T extends FieldValues>({
  name,
  control,
  label,
  errors,
  rules,
  ...rest
}: InputProps<T>) => {
  const error = getError(name, errors);
  return (
    <Controller
      render={({ field }) => (
        <FormControl>
          <FormControlLabel
            control={
              <MuiCheckbox
                size="small"
                id={name}
                value={field.value || ""}
                onChange={field.onChange}
                checked={field.value}
              />
            }
            label={<Typography fontSize="12px">{label}</Typography>}
          />
          <InputErrorText error={error?.message} sx={{ ml: 0 }} disablePopup />
        </FormControl>
      )}
      name={name}
      control={control}
      rules={rules}
      {...rest}
    />
  );
};
export default Checkbox;
